import { RootState } from '../types'

export const getFlows = (state: RootState) => state.flows.flows

export const selectedFlow = (state: RootState) => state.flows.selectedFlow

export const isValidating = (state: RootState) => state.flows.isValidating

export const isSaving = (state: RootState) => state.flows.isSaving

export const getFlowValidationResult = (state: RootState) => state.flows.validationResult
